import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../classes/user';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    API_USER_URL = config.serverAddress + ':' + config.serverPort + '/user/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_USER_URL + 'all');
    }
    getAllOrderByUsername() {
        return this.http.get(this.API_USER_URL + 'all/username');
    }
    getAllByIDRole(idRole: string | null) {
        return this.http.get(this.API_USER_URL + 'role/' + idRole);
    }
    getByID(id: string | null) {
        return this.http.get(this.API_USER_URL + id);
    }
    create(user: User) {
        return this.http.post(this.API_USER_URL + 'create', user);
    }
    update(user: User) {
        return this.http.put(this.API_USER_URL + 'update', user);
    }
    delete(id: number | undefined) {
        return this.http.delete(this.API_USER_URL + 'delete/' + id);
    }
}
